<div v-if="inline">
  <div class="card-body">
    <div v-if="selectedFiles.length" class="d-flex flex-wrap gap-3 mt-3 px-1">
      <div v-for="(item, index) in selectedFiles" :key="index" class="preview-item position-relative mb-2">
        <img v-if="item.mediaType === 'image'" :src="item.preview_url" class="w-100 h-100 object-fit-cover" @click="open_preview(item)"/>
        <video v-else-if="item.mediaType === 'video'" :src="item.preview_url" class="w-100 h-100 object-fit-cover" muted @click="open_preview(item)"></video>
        <div v-else class="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light text-primary text-center px-2" @click="open_preview(item)">
          <i class="bi bi-music-note-beamed fs-3"></i>
          <span class="text-xxxs text-truncate w-100">{{ item.name }}</span>
        </div>
        <button type="button"
          class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0  fs-6 px-2 py-0"
          @click="remove_selected_file(index)">
          &times;
        </button>
      </div>
    </div>

    <div>
      <div v-if="can_upload_media">
        <div
            class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
            :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
            @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false" @drop.prevent="handle_drop" @click="$refs.mediaFilesInput.click()">
            <div class="d-flex align-items-center justify-content-center gap-2 h-100">
              <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
              <span class="fw-bold text-black text-sm">Drag & Drop images, videos or audio here or click</span>
            </div>
            <input ref="mediaFilesInput" class="d-none" type="file" accept="image/*,video/*,audio/*" multiple @change="on_files_selected" />
          </div>
          <div class="d-flex flex-wrap gap-2 ms-auto justify-content-end align-items-center">
          <div class="form-check form-switch form-switch-xs m-0 me-2 ps-4 d-flex align-items-center gap-1">
            <input
              id="inline_public_gallery"
              v-model="public_gallery"
              class="form-check-input mt-0 me-1"
              type="checkbox"
              :disabled="is_saving_visibility"
              @change="save_gallery_visibility"
            />
            <label for="inline_public_gallery" class="form-check-label text-xxs fw-500 mb-0">
              Public gallery
            </label>
          </div>
          <button v-if="selectedFiles.length" type="button" class="btn btn-sm btn-danger text-xxs"
            @click="clear_selected_files">
            Clear
          </button>
          <button type="button" class="btn btn-sm btn-primary text-xxs" :disabled="!selectedFiles.length || isUploading"
            @click="upload_images">
            <span v-if="isUploading" class="spinner-border spinner-border-sm me-2"></span>
            Upload
          </button>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5 w-100">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 mb-0 text-muted text-xxs">Loading images...</p>
      </div>

      <div v-else class="row g-3 mt-3">
        <div v-for="item in media" :key="item.id" class="col-6 col-md-3">
          <div
            class="gallery-item-wrapper position-relative rounded shadow-sm border cursor-pointer"
            @click="open_preview(item)"

          >
            <img v-if="get_media_type(item) === 'image'" :src="item?.file?.file_url " class="w-100 h-100 object-fit-cover" />
            <video v-else-if="get_media_type(item) === 'video'" :src="item?.file?.file_url" class="w-100 h-100 object-fit-cover" muted></video>
            <div v-else-if="get_media_type(item) === 'audio'" class="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light text-primary text-center px-2">
              <i class="bi bi-music-note-beamed fs-1"></i>
              <span class="text-xxxs">Audio</span>
            </div>
            <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light text-muted text-xxs">
              Unsupported
            </div>
            <div v-if="can_upload_media" class="position-absolute top-0 end-0 m-2 d-flex gap-1">
              <button type="button"
                class="btn btn-sm shadow-sm px-2 py-1"
                :class="item.is_pinned ? 'btn-primary' : 'btn-light'"
                :title="item.is_pinned ? 'Unpin from top' : 'Pin to top'"
                @click.stop="toggle_pin(item)">
                <i class="bi" :class="item.is_pinned ? 'bi-pin-angle-fill' : 'bi-pin-angle'"></i>
              </button>

              <button type="button"
                class="btn btn-sm btn-danger shadow-sm px-2 py-1"
                title="Delete"
                @click.stop="delete_image(item)">
                <i class="bi bi-trash"></i>
              </button>

            </div>
          </div>
        </div>

        <div v-if="!media.length" class="text-center text-muted py-5 text-xxs">
          No images uploaded yet.
        </div>
      </div>
    </div>
  </div>
</div>

<teleport v-else to="body">
  <div class="modal fade" id="event_media_gallery_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">Event Media Gallery</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close" @click="reset"></button>
        </div>

        <div v-if="selectedFiles.length" class="d-flex flex-wrap gap-3 mt-3 px-1">
          <div v-for="(item, index) in selectedFiles" :key="index" class="preview-item position-relative mb-2">
            <img v-if="item.mediaType === 'image'" :src="item.preview_url" class="w-100 h-100 object-fit-cover" @click="open_preview(item)"/>
            <video v-else-if="item.mediaType === 'video'" :src="item.preview_url" class="w-100 h-100 object-fit-cover" muted @click="open_preview(item)"></video>
            <div v-else class="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light text-primary text-center px-2" @click="open_preview(item)">
              <i class="bi bi-music-note-beamed fs-3"></i>
              <span class="text-xxxs text-truncate w-100">{{ item.name }}</span>
            </div>
            <button type="button"
              class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0  fs-6 px-2 py-0"
              @click="remove_selected_file(index)">
              &times;
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="can_upload_media">
            <div
                class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
                :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false" @drop.prevent="handle_drop" @click="$refs.mediaFilesInput.click()">
                <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                  <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                  <span class="fw-bold text-black text-sm">Drag & Drop images, videos or audio here or click</span>
                </div>
                <input ref="mediaFilesInput" class="d-none" type="file" accept="image/*,video/*,audio/*" multiple @change="on_files_selected" />
              </div>
              <div class="d-flex gap-2 ms-auto justify-content-end">
              <button v-if="selectedFiles.length" type="button" class="btn btn-sm btn-danger text-xxs"
                @click="clear_selected_files">
                Clear
              </button>
              <button type="button" class="btn btn-sm btn-primary text-xxs" :disabled="!selectedFiles.length || isUploading"
                @click="upload_images">
                <span v-if="isUploading" class="spinner-border spinner-border-sm me-2"></span>
                Upload
              </button>
            </div>
          </div>

          <div v-if="isLoading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted text-xxs">Loading images...</p>
          </div>

          <div v-else class="row g-3 mt-3">
            <div v-for="item in media" :key="item.id" class="col-6 col-md-3">
              <div
                class="gallery-item-wrapper position-relative rounded shadow-sm border cursor-pointer"
                @click="open_preview(item)"

              >
                <img v-if="get_media_type(item) === 'image'" :src="item?.file?.file_url " class="w-100 h-100 object-fit-cover" />
                <video v-else-if="get_media_type(item) === 'video'" :src="item?.file?.file_url" class="w-100 h-100 object-fit-cover" muted></video>
                <div v-else-if="get_media_type(item) === 'audio'" class="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light text-primary text-center px-2">
                  <i class="bi bi-music-note-beamed fs-1"></i>
                  <span class="text-xxxs">Audio</span>
                </div>
                <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light text-muted text-xxs">
                  Unsupported
                </div>
                <div v-if="can_upload_media" class="position-absolute top-0 end-0 m-2 d-flex gap-1">
                  <button type="button"
                    class="btn btn-sm shadow-sm px-2 py-1"
                    :class="item.is_pinned ? 'btn-primary' : 'btn-light'"
                    :title="item.is_pinned ? 'Unpin from top' : 'Pin to top'"
                    @click.stop="toggle_pin(item)">
                    <i class="bi" :class="item.is_pinned ? 'bi-pin-angle-fill' : 'bi-pin-angle'"></i>
                  </button>

                  <button type="button"
                    class="btn btn-sm btn-danger shadow-sm px-2 py-1"
                    title="Delete"
                    @click.stop="delete_image(item)">
                    <i class="bi bi-trash"></i>
                  </button>

                </div>
              </div>
            </div>

            <div v-if="!media.length" class="text-center text-muted py-5 text-xxs">
              No images uploaded yet.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Preview Modal -->
<teleport to="body">
  <div class="modal fade" id="event_media_preview_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">Preview</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close_preview"
          ></button>
        </div>
        <div class="modal-body p-2">
          <img v-if="preview_url && preview_type === 'image'" :src="preview_url" class="w-100 rounded" />
          <video v-else-if="preview_url && preview_type === 'video'" :src="preview_url" class="w-100 rounded" controls autoplay></video>
          <audio v-else-if="preview_url && preview_type === 'audio'" :src="preview_url" class="w-100" controls autoplay></audio>
          <p v-else class="text-center text-muted text-xxs mb-0">No preview available for this media type.</p>
        </div>
      </div>
    </div>
  </div>
</teleport>
